import { ArrowRight, BookOpen, Bot, Gamepad2, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { gameGuideById } from "../gameGuides";
import { gameLaunchPath } from "../gameLaunchIntent";
import { roomGameCatalog } from "../roomGameCatalog";

export function GamesPage() {
  return (
    <section className="page-shell games-library">
      <div className="page-intro">
        <span className="eyebrow">READY TO PLAY</span>
        <h1>Nine games. Plenty of ways to win.</h1>
        <p>
          Every game shown here is live in Topzle today. Play with friends, start against a bot, and
          keep the conversation in the same room.
        </p>
      </div>
      <div className="catalog-grid">
        {roomGameCatalog.map((game, index) => {
          const guide = gameGuideById.get(game.id);
          return (
            <article className={`catalog-card game-color-${index % 6}`} key={game.id}>
              <div className="catalog-art">
                <span>{guide?.symbol ?? <Gamepad2 />}</span>
              </div>
              <span className="game-meta">{guide?.tagline ?? game.category}</span>
              <h2>{game.name}</h2>
              <p>{guide?.summary ?? game.description}</p>
              <div className="facts">
                <span>
                  <Users /> {game.playerCount} players
                </span>
                <span>
                  {game.ai && (
                    <>
                      <Bot /> Bot available
                    </>
                  )}
                </span>
              </div>
              <div className="catalog-actions">
                <Link className="button button-primary" to={gameLaunchPath(game.id)}>
                  Play now <ArrowRight />
                </Link>
                <Link className="button button-ghost" to={`/how-to-play/${game.id}`}>
                  <BookOpen /> How to play
                </Link>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
}
